import widgetI18n from 'widget/i18n/index';

const LOCALE_ALIASES = {
  zh: 'zh_CN',
  zh_HK: 'zh_TW',
  zh_Hans: 'zh_CN',
  zh_Hant: 'zh_TW',
  'pt-BR': 'pt_BR',
};

const normalizeLocale = locale => String(locale || 'en').replace('-', '_');

export const resolveWidgetLocale = locale => {
  const normalized = normalizeLocale(locale);
  const base = normalized.split('_')[0];
  const candidates = [
    normalized,
    LOCALE_ALIASES[normalized],
    LOCALE_ALIASES[base],
    base,
    'en',
  ].filter(Boolean);

  return candidates.find(key => Object.prototype.hasOwnProperty.call(widgetI18n, key)) || 'en';
};

export const getWidgetLocaleMessages = locale => {
  const key = resolveWidgetLocale(locale);
  return widgetI18n[key] || widgetI18n.en || {};
};

export const readWidgetLocaleText = (messages, path, fallback = '') => {
  if (!messages || !path) return fallback;
  const value = String(path)
    .split('.')
    .reduce((obj, key) => {
      if (!obj || typeof obj !== 'object') return undefined;
      return obj[key];
    }, messages);
  if (typeof value === 'string' && value.trim()) return value;
  return fallback;
};
